import {
  SET_DATES,
  SET_SELECTED_DATE
} from 'shared/actions/types';

export const setDates = dates => dispatch => {
  dispatch({
    type: SET_DATES,
    payload: dates
  });

  return Promise.resolve();
}

export const setSelectedDate = date => dispatch => {
  dispatch({
    type: SET_SELECTED_DATE,
    payload: date
  });

  return Promise.resolve();
}
